import { FC } from "react";
import { InboxIconContainerProps } from "@/components/side-navigation/inbox-icons/types";
import { InboxIcon } from "./inbox-icon";

export const InboxIconActive: FC<InboxIconContainerProps> = props => {
  return <InboxIcon {...props} isActive={true} />;
};
